<template>
  <div class="creditedDetailsInfo">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="form.InvoiceNo"
        :label="$t.creditedDetails.invoiceNo"
        readonly
        v-if="form.InvoiceNo"
      />
      <van-field
        v-model="form.FinancialAccountNo"
        :label="$t.creditedDetails.financialAccountNo"
        readonly
        v-if="form.FinancialAccountNo"
      />
      <van-field
        v-model="form.PWB_Number"
        :label="$t.creditedDetails.mainWbNumber"
        readonly
      />
      <van-field
        v-model="form.WB_Number"
        :label="$t.creditedDetails.sideWbNumber"
        readonly
      />
      <van-field
        v-model="form.WarehouseWorkNumber"
        :label="$t.creditedDetails.warehouseWorkNumber"
        readonly
      />
      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.creditedDetails.customerName"
        readonly
      />
      <van-field
        v-model="form.InvoiceDate"
        :label="$t.creditedDetails.createDate"
        readonly
      />

      <div class="title">{{ $t.creditedDetails.nuclearTitle }}</div>

      <div class="subTotal" v-if="form.ReceivedList && form.ReceivedList.length > 0">
        <div class="subTotal-label">
          {{ $t.creditedDetails.receivableAmount }}
        </div>
        <div
          class="subTotal-item"
          v-for="(item, index) in form.ReceivedList"
          :key="index"
        >
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>

      <div class="subTotal" v-if="form.PaidList && form.PaidList.length > 0">
        <div class="subTotal-label">{{ $t.creditedDetails.payableAmount }}</div>
        <div class="subTotal-item" v-for="(item, index) in form.PaidList" :key="index">
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>

      <div class="subTotal" v-if="form.Currency">
        <div class="subTotal-label">{{ $t.creditedDetails.verifyAmount }}</div>
        <div class="subTotal-item">
          <div class="item1">{{ form.Currency }}</div>
          <div class="item2">{{ form.CreditAmount }}</div>
        </div>
      </div>

      <div class="subTotal" v-if="form.BalanceList && form.BalanceList.length > 0">
        <div class="subTotal-label">{{ $t.creditedDetails.blance }}</div>
        <div class="subTotal-item" v-for="(item, index) in form.BalanceList" :key="index">
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>
    </van-form>

    <div class="tool-bar">
      <van-button type="info" block @click="toBillsReceivable" v-if="form.InvoiceNo">{{
        $t.creditedDetails.billDetail
      }}</van-button>
      <van-button
        type="primary"
        block
        @click="toSupplierCostEntry"
        v-if="form.FinancialAccountNo"
        >{{ $t.creditedDetails.viewCost }}</van-button
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "creditedDetailsInfo",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("creditedDetailsInfo"));
    this.form = data;
  },
  methods: {
    toBillsReceivable() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: this.form.InvoiceNo,
          },
        ],
      });
    },
    toSupplierCostEntry() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "supplierCostEntry",
        name: "supplierCostEntry",
        query: [
          {
            name: "FinancialAccountNo",
            value: this.form.FinancialAccountNo,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.creditedDetailsInfo {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
